import classNames from "classnames";
import React, { PropsWithChildren } from "react";

import styles from "./Container.module.css";

type PropTypes = {
  size?: "lg" | "md" | "sm";
  className?: string;
};

const Container: React.FC<PropsWithChildren<PropTypes>> = ({ children, size = "md", className }) => {
  return <div className={classNames(styles.container, styles[size], className)}>{children}</div>;
};

export default Container;
